<template>
  <div>
    <van-nav-bar
      v-if="$route.query.out || pageTitle"
      fixed
      left-arrow
      :safe-area-inset-top="true"
      @click-left="leftBut"
      @click-right="rightBut"
    >
      <template #title>
        <span style="fontsize: 18px; fontweight: 700; color: #333">
          {{ pageTitle }}
        </span>
      </template>
      <template #right>
        <van-icon v-if="isSandwich && !isShelves && hasShare" name="ellipsis" size="18" />
      </template>
    </van-nav-bar>
    <OpenAPP v-if="!$route.query.out && isDictionary" :pageTitle="pageTitle" />
    <AppExtension :isShelves="isShelves" v-if="isDictionary"/>
  </div>
</template>

<script>
import { NavBar, Icon } from "vant";
import AppExtension from "@/views/mobileView/detail/components/AppExtension.vue";
import OpenAPP from "@/views/mobileView/detail/components/openAPP.vue";
export default {
  name: "Header",
  components: {
    "van-nav-bar": NavBar,
    "van-icon": Icon,
    AppExtension,
    OpenAPP
  },
  props: {
    pageTitle: { // nav显示页面标题
      type: String,
    },
    isShelves: { // 页面是否已下架
      type: Boolean,
    },
    Share: {
      type: Object,
    },
    hasShare: { // 是否有分享按钮
      type: Boolean,
      default: true,
    },
    isDictionary: { // 词典页面
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      token: "", // 暂存token
      appShare: {}, // 分享参数
      // data:'' ,
      // typeToken:''
    };
  },
  computed: {
    isSandwich() {
      // 判断三明治显影
      return this.$route.query.out && !this.$route.query.app;
    },
  },
  watch: {
    Share() {
      this.appShare = this.Share;
    },
  },
  created() {},
  mounted() {
    this.appShare = this.Share;
  },
  methods: {
    // 左侧按钮(gubeit为协商的方法名)
    leftBut() {
      if (this.$route.query.out) {
        // 有out代表是APP进入
        if (this.$global.isAndroid_ios()) {
          window.android.gubeit();
        } else {
          window.webkit.messageHandlers.gubeit.postMessage("null"); //ios
        }
      } else {
        window.history.go(-1);
      }
    },
    // 右侧按钮((sharing为协商的方法名))
    rightBut() {
      let Url = this.eliminate()
      this.$set(this.appShare, "Url", Url + "share=false");
      const Share = JSON.stringify(this.appShare);
      if (this.$global.isAndroid_ios()) {
        window.android.sharing(Share);
      } else {
        window.webkit.messageHandlers.sharing.postMessage(Share); //ios
      }
    },
    eliminate() { // 分享 复制链接剔除特殊字段
      let url = document.location.toString();
      let urlArr = url.split("?");
      let baseUrl = urlArr[0]+'?'
      let params = Object.create(null);
      if (urlArr.length > 1) {
        urlArr = urlArr[1].split('&')
        urlArr.forEach(item => {
          item = item.split('=')
          if (item[0] === 'out' || item[0] === 'app' || item[0] === 'share' || item[0] === 'token') {
            return
          } {
            params[item[0]] = item[1]
          }
        })
      }
      for (const key in params) {
        baseUrl = baseUrl + [key] + '=' + params[key] + '&'
      }
      return baseUrl
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .van-nav-bar__content {
  height: 71px;
  border-bottom: 1px solid #dcdcdc;
}
::v-deep .van-icon-ellipsis:before {
  font-size: 25px;
  color: #333;
}
::v-deep .van-icon-arrow-left:before {
  font-size: 20px;
  color: #333;
}
.token {
  width: 100%;
  height: 300px;
  position: fixed;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.322);
  color: #fff;
  & div {
    word-wrap: break-word;
  }
}
</style>
